import { makeStyles } from "@material-ui/core";

export const useCardCargaStyles = makeStyles((theme) => ({
    containerHistorico: {
        display: 'flex',
        borderRadius: '10px',
        backgroundColor: '#F8F8F8',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        padding: theme.spacing(2),
    },
    rootApp: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    containerStatus: {
        display: 'flex',
        marginBottom: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    situacao: {
        width: '100%',
        height: '100%',
        marginLeft: theme.spacing(2),
        maxWidth: '100px',
        borderRadius: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(1)
    },
    titleSituacao: {
        color: '#858585',
        fontSize: '14px',
        fontWeight: 600
    },
    titleDate: {
        color: '#767676',
        fontSize: '14px',
        fontWeight: 600
    },
    titleStts: {
        color: '#fff',
        fontSize: '12px',
        fontWeight: 700
    },
    titleCargas: {
        color: '#767676',
        fontSize: '14px',
        fontWeight: 600
    },
    titleCargasSincronizados: {
        color: '#10C822',
        fontSize: '18px',
        fontWeight: 600
    },
    titleCargasRejeitados: {
        color: '#F44336',
        fontSize: '18px',
        fontWeight: 600
    },
    titleCargasPendentes: {
        color: '#FFBC00',
        fontSize: '18px',
        fontWeight: 600
    },
    titleTotalProdutos: {
        color: '#5333ED',
        fontSize: '18px',
        fontWeight: 600
    },
    titleCargasResult: {
        color: '#767676',
        fontSize: '18px',
        fontWeight: 700
    },
    date: {
        color: '#5333ED',
        fontSize: '16px',
        fontWeight: 600
    },

    divider: {
        width: '100%',
        height: '1px',
        marginBottom: 15,
        borderRadius: '6px',
        backgroundColor: '#E6E6E6'
    },
}));
